<template>
  <WindowFrame
    :component="'check'"
    class="ma-0 pa-0"
    :input_args="input_args"
    @loaded="handleCheckLoaded"
    ref="windowframe_check"
    @update_view="hdlUpdateView"
  />
</template>
  <script>
import WindowFrame from "@/components/WINDOWFRAME/WindowFrame.vue";

export default {
  name: "FrameCheckDossier",
  components: { WindowFrame },
  props: {},
  data() {
    return {
      // Variabili d'appoggio
      input_args: {
        dizionario: new Object(),
        esterno: 0,
        toolbar_btn_chiudi: true,
        toolbar_visible: false,
      },
      key_check: 0,

      // Modal
      // Array
    };
  },
  computed: {},
  watch: {
    variabile: {
      immediate: true,
      handler() {},
    },
  },
  methods: {
    handleCheckLoaded() {
      this.$refs.windowframe_check.postEvent("setparams", {
        landing_page: "dossier",
        dizionario: new Object(),
      });
    },
    hdlUpdateView() {
      this.key_check = this.key_check === 0 ? 1 : 0;
    },
  },
  created() {},
  mounted() {},
};
</script>
  <style scoped>
</style>